import axios, { AxiosResponse, ResponseType } from 'axios';
import { NavigateFunction } from 'react-router-dom';
import { AlertContextValue } from '../providers/AlertProvider';

export const get = async <T>(path: string): Promise<AxiosResponse<T>> => {
    return axios.get<T>(path);
}

export const getFile = async (path: string): Promise<AxiosResponse> => {
    return axios.get(path, { responseType: 'blob' });
}

export const post = async <T>(path: string, data?: any): Promise<AxiosResponse<T>> => {
    return axios.post(path, data, 
        {
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            }
        });
};

export const postForm = async <T>(path: string, data: any): Promise<AxiosResponse<T>> => {
    return axios.post(path, data);
};

export const put = async <T>(path: string, data?: any): Promise<AxiosResponse<T>> => {
    return axios.put(path, data, 
        {
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            }
        });
};

export const patch = <T>(path: string, data?: any): Promise<AxiosResponse<T>> => {
    return axios.patch(path, data, 
        {
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            }
        });
};

export const del = async <T>(path: string, data?: any): Promise<AxiosResponse<T>> => {
    return axios.delete(path,
        {
            data, 
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            }
        });
};

export const handleError = (error: any, alert: AlertContextValue, navigate: NavigateFunction) => {
    if (!error.response) {
        alert.error('Could not process. Please try again later');
        return;
    }
    const data = error.response.data;
    switch (error.status) {
        case 400:
            alert.warning(Array.isArray(data) ? data : 
                data.value ? data.value : data.error
            );
            break;
        case 401:
            if (window.location.port === "3000") {
                alert.error('Not logged in');
                return;
            }
            window.location.reload();
            break;
        case 403:
            navigate('/forbidden');
            break;
        default:
            alert.error('Oops, something went wrong.')
            console.error('Error: ' + data.value === undefined ? data : 
                data.value ? data.value : data.error
            );
            break;
    }
};
